/**
 * Company service — API calls for Client_Company management.
 */

import { api } from './api';

export interface Company {
  id: string;
  usual_name: string;
  client_code: string;
  domain: string;
  logo_s3_path: string | null;
  created_at: string;
  updated_at: string;
}

export interface CompanyCreatePayload {
  usual_name: string;
  client_code: string;
  domain: string;
}

export interface CompanyUpdatePayload {
  usual_name?: string;
  client_code?: string;
  domain?: string;
}

export const companyService = {
  async list(): Promise<Company[]> {
    const response = await api.get<{ data: Company[] }>('/admin/companies');
    return response.data;
  },

  async get(id: string): Promise<Company> {
    const response = await api.get<{ data: Company }>(`/admin/companies/${id}`);
    return response.data;
  },

  async create(payload: CompanyCreatePayload): Promise<Company> {
    const response = await api.post<{ data: Company }>('/admin/companies', payload);
    return response.data;
  },

  async update(id: string, payload: CompanyUpdatePayload): Promise<Company> {
    const response = await api.put<{ data: Company }>(`/admin/companies/${id}`, payload);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/admin/companies/${id}`);
  },

  async uploadLogo(id: string, file: File): Promise<Company> {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.upload<{ data: Company }>(`/admin/companies/${id}/logo`, formData);
    return response.data;
  },
};
